import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const BIGFOOTERBLOCK_LEGACY_FIELD_ORDER = [
  { type: 'groupedFields', handle: 'colors', fields: ["backgroundColor"] }
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  bigFooterBlockDescriptor: _generatedBigFooterBlockDescriptor,
  bigFooterBlockBlocDefinition,
  bigFooterBlockDashboardLayout,
  bigFooterBlockConfig,
  bigFooterBlockResolveConfig,
  bigFooterBlockProperties,
} = doodBlockConfig(
  {
    name: "Big footer",
    componentType: 'BigFooterBlockComponent',
    category: 'footer',
    description: "Big footer.",
    keywords: [],
    allowedIn: [
      { bloc: '*', slot: 'footer' },
    ],

    sharedFields: {},
    slots: [
      {
        key: 'left_body',
        name: 'pages.blocks.big-footer.left-body.label',
        accept: 'explicitOnly',
        allowedTypes: ["BigFooter.+Block", "CookieConsentLinkItemBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'columns',
        name: 'pages.blocks.big-footer.columns.label',
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterColumnBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    colors: {
      backgroundColor: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          label: "pages.blocks.big-footer.background-color.label",
        }
      })
    }
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.big-footer.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.big-footer.fieldset.appearance.label",
            fields: ["colors.backgroundColor"],
          },
          {
            legend: "pages.blocks.big-footer.fieldset.blocks.label",
            fields: ["left_body", "columns"],
          },
        ],
      },
    ],
  })
);

export function bigFooterBlockDescriptor(): IBlockDescriptor;
export function bigFooterBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function bigFooterBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedBigFooterBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedBigFooterBlockDescriptor, bigFooterBlockProperties, fieldOrder);
}

export {
  bigFooterBlockBlocDefinition,
  bigFooterBlockDashboardLayout,
  bigFooterBlockProperties,
  bigFooterBlockConfig,
  bigFooterBlockResolveConfig,
};

export type BigFooterBlockConfig = typeof bigFooterBlockConfig;
